import { render } from "./ImageFigureView.vue?vue&type=template&id=90cb8a2e&scoped=true"
import script from "./ImageFigureView.vue?vue&type=script&lang=js"
export * from "./ImageFigureView.vue?vue&type=script&lang=js"

import "./ImageFigureView.vue?vue&type=style&index=0&id=90cb8a2e&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cb8a2e"]])

export default __exports__